import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import { withRouter } from '@bibliocommons/utils-routing';
import { libraryShape, didNotFindOptionsShape, routerShape } from '@bibliocommons/bc-prop-types';

import Context from '@bibliocommons/context';

import { searchTypeShape } from 'app/shapes/search';
import SearchProbeListContainer from '../SearchProbeList/SearchProbeListContainer';
import BroadenSearchButtonContainer from '../BroadenSearchButton';
import DidYouMean from '../DidYouMean';
import RSSButton from '../RSSButton';
import DidNotFindDropdown from '../DidNotFindDropdown';
import ExternalSearchLink from '../ExternalSearchLink';
import SaveSearchButtonContainer from '../SaveSearchButton/SaveSearchButtonContainer';

import './SearchTitle.scss';

class SearchTitle extends React.PureComponent {
  renderSearchTitleContent() {
    const { query, titleKey, searchType, intl, broadened } = this.props;

    if (!query && !this.props.router.query.title && !titleKey) {
      return <FormattedMessage id="no_results_found" />;
    }

    const localizedSearchType = intl.formatMessage({
      id: `Search.searchTypes.${broadened ? 'bkw' : searchType}`
    });
    const localizedTitle = titleKey ? intl.formatMessage({ id: titleKey }) : null;

    return (
      this.props.router.query.title ||
      localizedTitle || (
        <FormattedMessage
          id="SearchTitle.typeResultsForQuery"
          values={{
            type: localizedSearchType,
            query: <strong>{query}</strong>
          }}
        />
      )
    );
  }

  renderSearchTitle() {
    const content = this.renderSearchTitleContent();
    return (
      <h1 key="titleForCurrentSearch" data-test-id="searchTitle" className="search-query">
        {content}
      </h1>
    );
  }

  renderBroadenSearchButton() {
    const { broadened, broadenedSearchType, query, searchType, library } = this.props;

    return (
      <BroadenSearchButtonContainer
        library={library}
        query={query}
        searchType={searchType}
        broadenedSearchType={broadenedSearchType}
        isBroadened={broadened}
      />
    );
  }

  renderDidYouMean() {
    const { didYouMeanQuerySuggestion, didYouMeanResultCount, showDidYouMean } = this.props;

    return (
      showDidYouMean && (
        <DidYouMean
          key="did-you-mean"
          querySuggestion={didYouMeanQuerySuggestion}
          resultCount={didYouMeanResultCount}
        />
      )
    );
  }

  renderDidNotFindDropdown() {
    const { didNotFindOptions, query, searchType, showExternalSearchLink } = this.props;

    return didNotFindOptions.get('isEnabled') ? (
      <DidNotFindDropdown
        query={query}
        searchType={searchType}
        showExternalSearchLink={showExternalSearchLink}
        didNotFindOptions={didNotFindOptions}
      />
    ) : (
      <ExternalSearchLink query={query} searchType={searchType} />
    );
  }

  renderSavedSearchButton() {
    const { query } = this.props;
    if (!this.context.mobileApp && query) {
      return <SaveSearchButtonContainer />;
    }
    return null;
  }

  renderModifyLink() {
    const { customEdit, intl, query, searchType } = this.props;
    const searchUrl = `/search?custom_edit=${customEdit}&query=${encodeURIComponent(query)}`;

    if (searchType !== 'bl' || this.context.mobileApp) {
      return null;
    }

    return (
      <a href={searchUrl} className="modify-search-link" data-test-id="modify-search-link">
        {intl.formatMessage({ id: 'form_label_modify_my_search' })}
      </a>
    );
  }

  renderRSSButton() {
    const { rssURL } = this.props;

    if (!this.context.mobileApp && rssURL) {
      return <RSSButton url={rssURL} />;
    }

    return null;
  }

  render() {
    const { query, suppress } = this.props;

    return (
      <div className="row cp-search-title" data-test-id="search-title">
        <div className="col-12 col-xs-12 search-title-block" aria-atomic="true">
          <div className="search-term">
            <div className="main-row">
              <div className="search-title-rss">
                {this.renderSearchTitle()}
                <span className="rss-button-mobile">{this.renderRSSButton()}</span>
              </div>
              <div className="right-buttons">
                {this.renderSavedSearchButton()}
                <span className="rss-button-desktop">{this.renderRSSButton()}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-xs-12 search-links">
          {this.renderDidYouMean()}
          {!suppress && query ? this.renderBroadenSearchButton() : null}
          {this.renderModifyLink()}
          {this.renderDidNotFindDropdown()}
        </div>

        <div className="other-search-tools">
          <SearchProbeListContainer />
        </div>
      </div>
    );
  }
}

SearchTitle.propTypes = {
  titleKey: PropTypes.string,
  customEdit: PropTypes.bool,
  suppress: PropTypes.bool,
  searchType: searchTypeShape.isRequired,
  query: PropTypes.string,
  broadenedSearchType: PropTypes.string,
  broadened: PropTypes.bool,
  didYouMeanResultCount: PropTypes.number,
  didYouMeanQuerySuggestion: PropTypes.string,
  showExternalSearchLink: PropTypes.bool,
  rssURL: PropTypes.string,
  didNotFindOptions: didNotFindOptionsShape,
  showDidYouMean: PropTypes.bool,
  library: libraryShape,
  router: routerShape.isRequired
};

SearchTitle.defaultProps = {
  showDidYouMean: true
};

SearchTitle.contextType = Context;

export default withRouter(injectIntl(SearchTitle));
